import React from 'react';
import PropTypes from 'prop-types';
import Img from '../../Img';

import styles from './pbrRating.scss';

const PbrRating = (props) => {
    const { pbrRating, pbrClass, showLabel, 'data-testid': dataTestId } = props;
    const label = showLabel ? pbrRating?.ratingDisplay : pbrRating?.value;

    return (
        <div className={`${styles.pbrRating} d-flex aic ${pbrClass} content-wrapper`} data-testid={dataTestId || undefined}>
            <Img className="ballImg" src={`/img/progression_ball_${pbrRating?.pbrBallColor}.svg`} /> <div data-testid={dataTestId && `${dataTestId}.label`}>{label}</div>
        </div>
    );
};

PbrRating.propTypes = {
    'data-testid': PropTypes.string,
};

PbrRating.defaultProps = {
    'data-testid': null,
};

export default PbrRating;
